import { render, staticRenderFns } from "./EventDetailPopover.vue?vue&type=template&id=28d9c91a&scoped=true&"
import script from "./EventDetailPopover.vue?vue&type=script&lang=js&"
export * from "./EventDetailPopover.vue?vue&type=script&lang=js&"
import style0 from "./EventDetailPopover.vue?vue&type=style&index=0&id=28d9c91a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d9c91a",
  null
  
)

export default component.exports